
import axios from 'axios'

export default class Manual {
    constructor(tokenBearer, url, id) {
        this.url = url
        this.tokenBearer = tokenBearer
        this.id = id
    }

    getManual() {
        return new Promise(async (resolve, reject) => {
            let optionsManual = {
                method: 'get',
                url: `${this.url}/api/unimed/manual`,
                headers: {
                    'Authorization': this.tokenBearer,
                    'Content-Type': 'multipart/form-data'
                }
            }
            try {
                let responseManual = await axios(optionsManual)
                resolve(responseManual)
            } catch (err) {
                reject(err)
            }
        })
    }
    getNome() {
        return new Promise(async (resolve, reject) => {
            let optionsManual = {
                method: 'get',
                url: `${this.url}/api/unimed/manual/vigente`,
                headers: {
                    'Authorization': this.tokenBearer
                }
            }
            try {
                let responseManual = await axios(optionsManual)
                resolve(responseManual)
            } catch (err) {
                reject(err)
            }
        })
    }
    getUuid() {
        return new Promise(async (resolve, reject) => {
            let optionsManual = {
                method: 'get',
                url: `${this.url}/api/unimed/manual/uuid`,
                headers: {
                    'Authorization': this.tokenBearer
                }
            }
            try {
                let responseManual = await axios(optionsManual)
                resolve(responseManual)
            } catch (err) {
                reject(err)
            }
        })
    }
    setManual(data) {
        return new Promise(async (resolve, reject) => {
            let optionsManual = {
                method: 'post',
                url: `${this.url}/api/unimed/manual`,
                headers: {
                    'Authorization': this.tokenBearer,
                    'Content-Type': 'multipart/form-data'
                },
                data: data
            }

            try {
                let responseManual = await axios(optionsManual)
                resolve(responseManual)
            } catch (err) {
                reject(err)
            }
        })
    }
    exportar(urlDownload) {
        return new Promise(async (resolve, reject) => {
            let optionsManual = {
                method: 'get',
                url: urlDownload,
                headers: {
                    'Authorization': this.tokenBearer
                },
                responseType: 'blob'
            }

            try {
                let responseManual = await axios(optionsManual)
                resolve(responseManual)
            } catch (err) {
                reject(err)
            }
        })
    }
}